module.exports = __webpack_public_path__ + "static/buildup_title-2113110c12da4373e65afcbd24eac42d.png";